export default "__VITE_ASSET__3mzYWWLt__"